import { BaseConfig } from '@ti/core/contracts/config'

export default {
  envType: 'production',
  googleTagManagerId: '',
  awsRegion: 'us-east-2',
  awsMapName: 'ti-fleet-app-esri',
  awsMapApiKey:
    'v1.public.eyJqdGkiOiI5NzJjYTI2OC0wMjVjLTQzNjItYTljZS0wOGQxZGZlZDYwOGQifUr4Ru38se7LSq-Ie6j3cOBQrK8VUO8nIrFt0kEUb59bi_Ub4aUHq1Og7NioTP32Ps5P5vprCe9EGrBzT8HsRcIU6yfCJO-Arx_bRDeCDI_m0VQq5ysXtA3_EF0u8Sk0K-sgKh3mk7Ti0NCiTshces_F31--27Prm-vfma5Z_JGZfVu0WwWlwfLOjq9i0k0s2PMxdWZKHeabf5e1VPMuFDR-iZ6l6wmZzQBi3YdgOMXcuwY9M47hjx4-CZUZTHF7sNu0gjndbFpuoZxiBOg6yAqed_7okEtxaR9aqukCrspGk43vPUi8ykppwIef3Yb8UY-3bztLYaZ7Ircmf5e_EBU.NjAyMWJkZWUtMGMyOS00NmRkLThjZTMtODEyOTkzZTUyMTBi',
  // Esri Imagery
  esriSatelliteMapName: '',
  esriSatelliteMapApiKey: '',
  // HERE Hybrid
  hereHybridMapName: 'fleet-web-satellite',
  hereHybridMapApiKey:
    'v1.public.eyJqdGkiOiJmY2U0NTZmOS0wM2VlLTQ3NjgtODlhYS1iYzllOWExOGMzNmEifR1J4YbCxiKFbejVHY2u5JY47HxlQh-jDQ0GELcAiRi85aaSNBoaulI8hmMYbiXsnk05HjwUYWomYbdIMf8uGDu9agY5vT3KxB1j65D_h6SyiqAA1g0VlOqYHHbRGGJGR7PvvTFmL4h5nkGwnCuDBSDsACTq64G4RT1MEgNysenxdeRH62LegZopeFrQzahr49XbwHpqM0PF7uo0OMpykJflJ4Ratt8GZJbmGR6hassX59d1tbgoQm2Ovmu_q55IxZdAdPPgUlFT716htiCBxUJD7_qmkOj-FzUF_YsfQOkD_iQsjFpFKJF2gGku81hoHmJgNICDVwyyIQ0R4WxMwvg.NjAyMWJkZWUtMGMyOS00NmRkLThjZTMtODEyOTkzZTUyMTBi',
  // Esri Imagery
  hereSatelliteMapName: '',
  hereSatelliteMapApiKey: '',
  mapTilerApiKey: '',
  mapTilerStyleName: 'streets-v2-light',
  flespiUrl: 'https://flespi.io',
  apiUrl: 'https://hhdpwfpikjnzxkh62qjbdmbw7q0uacnv.lambda-url.us-east-2.on.aws',
  reportsApiUrl: 'https://hhdpwfpikjnzxkh62qjbdmbw7q0uacnv.lambda-url.us-east-2.on.aws',
  tspDefaultDomain: 'admin.telematicsinsights.ai',
  fleetDefaultDomain: 'app.telematicsinsights.ai',
  sentry: {
    enabled: true,
    project: 'fleet-web-app',
    dsn: 'https://4c79d7f433ef04e83c1a13ea3f88d1f7@o4507342474313728.ingest.us.sentry.io/4508098087288832',
    tracePropagationTargets: [
      'https://app.telematicsinsights.ai',
      'https://connect.telematicsinsights.ai',
      'https://hhdpwfpikjnzxkh62qjbdmbw7q0uacnv.lambda-url.us-east-2.on.aws',
    ],
  },
  push: {
    instanceId: '',
  },
  amplify: {
    userPoolId: 'us-east-2_Y3nn6int6',
    identityPoolId: 'us-east-2:14864f66-e553-4e39-8f20-a52b823c0b33',
    userPoolClientId: '4bkar6qd7d7uabuk5aceq9ed9d',
  },
  firebase: {
    apiKey: 'AIzaSyAsKpb4LgqVUF8IvtuHwaGg1t9HDsFX6tI',
    authDomain: 'ti-prod-78b69.firebaseapp.com',
    projectId: 'ti-prod-78b69',
    storageBucket: 'ti-prod-78b69.appspot.com',
    messagingSenderId: '391591403298',
    appId: '1:391591403298:web:c10e7aa530e2fae5294f7b',
    measurementId: 'G-2R3W7HESCW',
  },
  fcmVapidKey:
    'BCnGFaOR2c9sboSx2v0TIV-l8UV0cDp709shRsXnXOw1Ip6oyFddZdTfQZvS1ojw7wN8fdiD9bA4FruM9ABCs64',
  datadog: {
    applicationId: 'c7016a3e-ea80-4274-9b4e-21ee594f37b2',
    clientToken: 'pubf4f163ad9c5cdf807c95a50dced09045',
  },
} as BaseConfig
